import * as c from '../constants/ApprovalRequestConstants'

const initialState = {
  approvalHistory: {},
  submitting: false,
  submitted: false,
  error: null
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case c.SUBMIT_APPROVAL_REQUEST_PENDING:
      return { ...state, submitting: true, submitted: false, error: null }

    case c.SUBMIT_APPROVAL_REQUEST_FULFILLED:
      return { ...state, submitting: false, submitted: true, approvalHistory: { ...payload.approvalHistory }}

    case c.SUBMIT_APPROVAL_REQUEST_REJECTED:
      return { ...state, submitting: false, submitted: false, error: payload }

    case c.RESET_APPROVAL_REQUEST:
      return initialState

    default:
      return state
  }
}
